export const UniversitiesList = [
    // { value: null, label: "Select University" },
    { value: "NUST", label: "NUST" },
    { value: "LUMS", label: "LUMS" },
    { value: "LSE", label: "LSE" },
    { value: "SZABIST Karachi", label: "SZABIST Karachi" },
    { value: "GIKI", label: "GIKI" },
    { value: "Habib University", label: "Habib University" },
    { value: "IoBM", label: "IoBM" },
    { value: "FAST Lahore", label: "FAST Lahore" },
    { value: "PU", label: "PU" },
    {value: "IBA", label: "IBA"},
    { value: "ITU", label: "ITU" },
    { value: "UET", label: "UET" },
    {value: "Abasyn University", label: "Abasyn University"},
    {value: "Abdul Wali Khan University Mardan", label: "Abdul Wali Khan University Mardan"},
    {value: "ACCA Pakistan", label: "ACCA Pakistan"},
    {value: "Adamjee Govt Science College", label: "Adamjee Govt Science College"},
    {value: "Aga Khan University, Medical College", label: "Aga Khan University, Medical College"},
    {value: "Aitchison College, Lahore", label: "Aitchison College, Lahore"},
    {value: "Air University", label: "Air University"},
    {value: "Akhtar Saeed Medical and Dental College", label: "Akhtar Saeed Medical and Dental College"},
    {value: "Al-Khair University", label: "Al-Khair University"},
    {value: "Al-Murtaza School", label: "Al-Murtaza School"},
    {value: "Ali Garh Institute of Techonolgy, Karachi", label: "Ali Garh Institute of Techonolgy, Karachi"},
    {value: "Allama Iqbal Medical College", label: "Allama Iqbal Medical College"},
    {value: "Allama Iqbal Open University (AIOU)", label: "Allama Iqbal Open University (AIOU)"},
    {value: "Altamash Institute of Dental Medicine", label: "Altamash Institute of Dental Medicine"},
    {value: "Amina Inayat Medical College", label: "Amina Inayat Medical College"},
    {value: "Army Medical College", label: "Army Medical College"},
    {value: "Avicenna Medical College", label: "Avicenna Medical College"},
    {value: "Ayub Medical College", label: "Ayub Medical College"},
    {value: "Bahauddin Zakariya University", label: "Bahauddin Zakariya University"},
    {value: "Bahria College", label: "Bahria College"},
    {value: "Bahria University", label: "Bahria University"},
    {value: "Bahria University Medical and Dental College", label: "Bahria University Medical and Dental College"},
    {value: "Balochistan Board", label: "Balochistan Board"},
    {
        value: "Balochistan University of Engineering and Technology",
        label: "Balochistan University of Engineering and Technology"
    },
    {
        value: "Balochistan University of Information Technology and Management Sciences",
        label: "Balochistan University of Information Technology and Management Sciences"
    },
    {value: "Baqai Medical &amp; Dental University", label: "Baqai Medical &amp; Dental University"},
    {value: "Baqai Medical University", label: "Baqai Medical University"},
    {value: "Beaconhouse National University", label: "Beaconhouse National University"},
    {value: "Benazir Bhutto Shaheed University", label: "Benazir Bhutto Shaheed University"},
    {value: "Bolan Medical College", label: "Bolan Medical College"},
    {value: "C.M.A Boys Secondary School Karachi", label: "C.M.A Boys Secondary School Karachi"},
    {value: "Cambridge University", label: "Cambridge University"},
    {
        value: "Capital University of Science &amp; Technology, Islamabad",
        label: "Capital University of Science &amp; Technology, Islamabad"
    },
    {
        value: "CECOS University of Information Technology and Emerging Sciences",
        label: "CECOS University of Information Technology and Emerging Sciences"
    },
    {value: "Central Park Medical College", label: "Central Park Medical College"},
    {
        value: "Centre for Advanced Studies in Engineering (CASE), Islamabad",
        label: "Centre for Advanced Studies in Engineering (CASE), Islamabad"
    },
    {value: "Chandka Medical College", label: "Chandka Medical College"},
    {value: "Chartered Institute of Management Accountants", label: "Chartered Institute of Management Accountants"},
    {
        value: "City University of Science &amp; Information Technology",
        label: "City University of Science &amp; Information Technology"
    },
    {value: "Civil Aviation Model High School Hyd", label: "Civil Aviation Model High School Hyd"},
    {value: "CMH Lahore Medical College", label: "CMH Lahore Medical College"},
    {value: "College Of Digital Science", label: "College Of Digital Science"},
    {value: "College of Physicians &amp; Surgeons", label: "College of Physicians &amp; Surgeons"},
    {
        value: "College of Tourism and Hotel Management Lahore(Cothm)",
        label: "College of Tourism and Hotel Management Lahore(Cothm)"
    },
    {value: "COMSATS Institute of Information Technology", label: "COMSATS Institute of Information Technology"},
    {
        value: "Construction Technology Training Institute Islamabad",
        label: "Construction Technology Training Institute Islamabad"
    },
    {value: "Continental Medical College", label: "Continental Medical College"},
    {value: "Corks Govt Sec College", label: "Corks Govt Sec College"},
    {value: "DA Degree College for Women", label: "DA Degree College for Women"},
    {value: "Dadabhoy Institute of Higher Education", label: "Dadabhoy Institute of Higher Education"},
    {value: "Dawood Public School", label: "Dawood Public School"},
    {
        value: "Dawood University of Engineering &amp; Technology (DCET)",
        label: "Dawood University of Engineering &amp; Technology (DCET)"
    },
    {value: "DHA Degree College", label: "DHA Degree College"},
    {value: "DHA Suffa University Karachi", label: "DHA Suffa University Karachi"},
    {value: "Dow International Medical College", label: "Dow International Medical College"},
    {value: "DOW UNIVERSITY OF HEALTH SCIENCES.", label: "DOW UNIVERSITY OF HEALTH SCIENCES."},
    {value: "Dukhta-e-Awam SEC School", label: "Dukhta-e-Awam SEC School"},
    {value: "Edexcel", label: "Edexcel"},
    {value: "Fatima Jinnah Dental College &amp; Hospital", label: "Fatima Jinnah Dental College &amp; Hospital"},
    {value: "Fatima Jinnah Medical College", label: "Fatima Jinnah Medical College"},
    {value: "Fatima Jinnah Women University", label: "Fatima Jinnah Women University"},
    {
        value: "Federal Urdu University of Arts, Sciences and Technology",
        label: "Federal Urdu University of Arts, Sciences and Technology"
    },
    {value: "FMH College of Medicine and Dentistry", label: "FMH College of Medicine and Dentistry"},
    {value: "Forman Christian College", label: "Forman Christian College"},
    {value: "Foundation University", label: "Foundation University"},
    {value: "Frontier Medical College", label: "Frontier Medical College"},
    {value: "Frontier Women University", label: "Frontier Women University"},
    {value: "G. Science &amp; Commerce College", label: "G. Science &amp; Commerce College"},
    {value: "Gandhara University", label: "Gandhara University"},
    {value: "Ghazi University, Dera Ghazi Khan", label: "Ghazi University, Dera Ghazi Khan"},
    {
        value: "Ghulam Ishaq Khan Institute of Engineering Sciences &amp; Technology",
        label: "Ghulam Ishaq Khan Institute of Engineering Sciences &amp; Technology"
    },
    {value: "Ghulam Muhammad Mahar Medical College", label: "Ghulam Muhammad Mahar Medical College"},
    {value: "GIFT University", label: "GIFT University"},
    {value: "Global Institute, Lahore", label: "Global Institute, Lahore"},
    {value: "Gomal Medical College", label: "Gomal Medical College"},
    {value: "Gomal University", label: "Gomal University"},
    {value: "Government College University", label: "Government College University"},
    {value: "Government College University Faisalabad.", label: "Government College University Faisalabad."},
    {value: "Govt High School Daharki", label: "Govt High School Daharki"},
    {value: "Govt Muslim Sc college Hyderabad", label: "Govt Muslim Sc college Hyderabad"},
    {value: "Govt. College of Commerce Vehari", label: "Govt. College of Commerce Vehari"},
    {value: "Govt. Degree Science &amp; Commerce College", label: "Govt. Degree Science &amp; Commerce College"},
    {value: "Green Public School", label: "Green Public School"},
    {value: "Greenwich University", label: "Greenwich University"},
    {value: "Habib University Foundation", label: "Habib University Foundation"},
    {value: "Hajvery University", label: "Hajvery University"},
    {value: "Hamdard College of Medicine and Dentistry", label: "Hamdard College of Medicine and Dentistry"},
    {value: "Hamdard University", label: "Hamdard University"},
    {value: "Hazara University, Dodhial", label: "Hazara University, Dodhial"},
    {value: "HITEC University Taxilla", label: "HITEC University Taxilla"},
    {value: "Imperial College of Business Studies", label: "Imperial College of Business Studies"},
    {value: "Independent Medical College", label: "Independent Medical College"},
    {value: "Indus Institute of Higher Education", label: "Indus Institute of Higher Education"},
    {value: "Indus Valley School of Art and Architecture", label: "Indus Valley School of Art and Architecture"},
    {value: "Information Technology University", label: "Information Technology University"},
    {
        value: "Institute of Business &amp; Technology - BIZTEK",
        label: "Institute of Business &amp; Technology - BIZTEK"
    },
    {value: "Institute of Business Administration (IBA)", label: "Institute of Business Administration (IBA)"},
    {value: "Institute of Business Management (IoBM)", label: "Institute of Business Management (IoBM)"},
    {value: "Institute of Chartered Accountants of Pakistan", label: "Institute of Chartered Accountants of Pakistan"},
    {
        value: "Institute of Cost &amp; Management Accountancy of Pakistan (ICMAP)",
        label: "Institute of Cost &amp; Management Accountancy of Pakistan (ICMAP)"
    },
    {value: "Institute of Management Sciences", label: "Institute of Management Sciences"},
    {value: "Institute of Southern Punjab, Multan", label: "Institute of Southern Punjab, Multan"},
    {value: "Institute of Space Technology, Islamabad", label: "Institute of Space Technology, Islamabad"},
    {value: "International Islamic University", label: "International Islamic University"},
    {value: "Iqra University", label: "Iqra University"},
    {value: "Islamabad Medical and Dental College", label: "Islamabad Medical and Dental College"},
    {value: "Islamia University", label: "Islamia University"},
    {value: "Islamic International Medical College", label: "Islamic International Medical College"},
    {value: "Isra University", label: "Isra University"},
    {value: "Jinnah Medical and Dental College", label: "Jinnah Medical and Dental College"},
    {value: "Jinnah Sindh Medical University", label: "Jinnah Sindh Medical University"},
    {value: "Jinnah University for Women", label: "Jinnah University for Women"},
    {value: "JPMC", label: "JPMC"},
    {value: "Kabir Medical College", label: "Kabir Medical College"},
    {value: "Karachi Medical and Dental College", label: "Karachi Medical and Dental College"},
    {value: "Karachi Public High School", label: "Karachi Public High School"},
    {
        value: "Karachi School for Business &amp; Leadership (KSBL)",
        label: "Karachi School for Business &amp; Leadership (KSBL)"
    },
    {value: "Karakurum International University", label: "Karakurum International University"},
    {value: "Kazakh State Medical University", label: "Kazakh State Medical University"},
    {
        value: "Khadim Ali Shah Bukhari Institute of Technology",
        label: "Khadim Ali Shah Bukhari Institute of Technology"
    },
    {value: "Khursheed GG School", label: "Khursheed GG School"},
    {
        value: "Khwaja Fareed University of Engineering &amp; Information Technology (KFUEIT",
        label: "Khwaja Fareed University of Engineering &amp; Information Technology (KFUEIT"
    },
    {value: "Khyber Medical College", label: "Khyber Medical College"},
    {value: "Khyber Medical University", label: "Khyber Medical University"},
    {value: "King Edward Medical University", label: "King Edward Medical University"},
    {value: "Kinnaird College for Women", label: "Kinnaird College for Women"},
    {value: "Kohat University of Science &amp; Technology", label: "Kohat University of Science &amp; Technology"},
    {value: "KUST Institute of Medical Sciences", label: "KUST Institute of Medical Sciences"},
    {value: "Kyrgyz Medical Academy", label: "Kyrgyz Medical Academy"},
    {value: "Lahore College for Women University", label: "Lahore College for Women University"},
    {value: "Lahore Garrison University", label: "Lahore Garrison University"},
    {value: "Lahore Leads University", label: "Lahore Leads University"},
    {value: "Lahore Medical and Dental College", label: "Lahore Medical and Dental College"},
    {value: "Lahore School of Economics", label: "Lahore School of Economics"},
    {
        value: "Lahore University of Management Sciences (LUMS)",
        label: "Lahore University of Management Sciences (LUMS)"
    },
    {value: "Liaquat College of Medicine and Dentistry", label: "Liaquat College of Medicine and Dentistry"},
    {value: "Liaquat National Medical College", label: "Liaquat National Medical College"},
    {
        value: "Liaquat University of Medical and Health Sciences",
        label: "Liaquat University of Medical and Health Sciences"
    },
    {value: "LOGIX College", label: "LOGIX College"},
    {value: "M.A.I.U.M (USA)", label: "M.A.I.U.M (USA)"},
    {
        value: "Mehran University of Engineering &amp; Technology",
        label: "Mehran University of Engineering &amp; Technology"
    },
    {value: "Minhaj University", label: "Minhaj University"},
    {
        value: "Mirpur University of Science &amp; Technology (MUST)",
        label: "Mirpur University of Science &amp; Technology (MUST)"
    },
    {value: "Mohammad Ali Jinnah University", label: "Mohammad Ali Jinnah University"},
    {value: "Mohi-ud-Din Islamic University", label: "Mohi-ud-Din Islamic University"},
    {value: "Mohiuddin Islamic Medical College", label: "Mohiuddin Islamic Medical College"},
    {value: "Muhammad Medical College", label: "Muhammad Medical College"},
    {value: "Multan Medical and Dental College", label: "Multan Medical and Dental College"},
    {value: "National College of Arts", label: "National College of Arts"},
    {
        value: "National College of Business Administration &amp; Economics (NCBA&amp;E)",
        label: "National College of Business Administration &amp; Economics (NCBA&amp;E)"
    },
    {value: "National Defence University, Islamabad", label: "National Defence University, Islamabad"},
    {value: "National High School", label: "National High School"},
    {
        value: "National Textile University, Faisalabad, (Federal Chartered)",
        label: "National Textile University, Faisalabad, (Federal Chartered)"
    },
    {value: "National University of  Modern Language (NUML)", label: "National University of  Modern Language (NUML)"},
    {
        value: "National University of Computer and Emerging Sciences",
        label: "National University of Computer and Emerging Sciences"
    },
    {value: "National University of Modern Languages", label: "National University of Modern Languages"},
    {value: "National University of Science and Technology", label: "National University of Science and Technology"},
    {value: "Nawaz Sharif Medical College", label: "Nawaz Sharif Medical College"},
    {value: "NED University of Engineering &amp; Technology", label: "NED University of Engineering &amp; Technology"},
    {value: "Netsol Technology Institute", label: "Netsol Technology Institute"},
    {
        value: "Newport Institute of Communication and Economics",
        label: "Newport Institute of Communication and Economics"
    },
    {
        value: "NFC Institute of Engineering &amp; Technology, Multan",
        label: "NFC Institute of Engineering &amp; Technology, Multan"
    },
    {value: "Nicon Group of Colleges", label: "Nicon Group of Colleges"},
    {value: "Nishtar Medical College", label: "Nishtar Medical College"},
    {value: "Northern University", label: "Northern University"},
    {value: "NWFP Agricultural University", label: "NWFP Agricultural University"},
    {
        value: "NWFP University of Engineering &amp; Technology",
        label: "NWFP University of Engineering &amp; Technology"
    },
    {
        value: "PAF Karachi Institute of Economics &amp; Technology (PAF-KIET)",
        label: "PAF Karachi Institute of Economics &amp; Technology (PAF-KIET)"
    },
    {value: "Pakistan Board of Technical Education Lahore", label: "Pakistan Board of Technical Education Lahore"},
    {
        value: "Pakistan Institute of Development Economics (PIDE)",
        label: "Pakistan Institute of Development Economics (PIDE)"
    },
    {
        value: "Pakistan Institute of Engineering and Applied Sciences (PIEAS)",
        label: "Pakistan Institute of Engineering and Applied Sciences (PIEAS)"
    },
    {
        value: "Pakistan Institute of Fashion and Design (PIFD)",
        label: "Pakistan Institute of Fashion and Design (PIFD)"
    },
    {value: "Pakistan Institute of Management", label: "Pakistan Institute of Management"},
    {value: "Pakistan Military Academy", label: "Pakistan Military Academy"},
    {value: "Pakistan Naval Academy", label: "Pakistan Naval Academy"},
    {value: "PECHS", label: "PECHS"},
    {value: "PECHS Govt College", label: "PECHS Govt College"},
    {value: "PECHS Govt.College for Women", label: "PECHS Govt.College for Women"},
    {value: "Peoples Medical College, Nawabshah", label: "Peoples Medical College, Nawabshah"},
    {value: "Peshawar Medical College", label: "Peshawar Medical College"},
    {value: "Peshawar University", label: "Peshawar University"},
    {value: "PMDC", label: "PMDC"},
    {
        value: "Preston Institute of Management Sciences and Technology",
        label: "Preston Institute of Management Sciences and Technology"
    },
    {value: "Preston University", label: "Preston University"},
    {value: "Public School", label: "Public School"},
    {value: "Punjab Medical College", label: "Punjab Medical College"},
    {
        value: "Quaid-e-Awam University of Engineering, Science &amp; Technology",
        label: "Quaid-e-Awam University of Engineering, Science &amp; Technology"
    },
    {value: "Quaid-e-Azam Medical College", label: "Quaid-e-Azam Medical College"},
    {value: "Quaid-i-Azam University", label: "Quaid-i-Azam University"},
    {value: "Queen Mary Public School Karachi", label: "Queen Mary Public School Karachi"},
    {
        value: "Qurtaba University of Science and Information Technology",
        label: "Qurtaba University of Science and Information Technology"
    },
    {value: "Rashid Latif Medical College", label: "Rashid Latif Medical College"},
    {value: "Rawalpindi Medical College", label: "Rawalpindi Medical College"},
    {value: "Riphah International University", label: "Riphah International University"},
    {value: "Saidu Medical College", label: "Saidu Medical College"},
    {value: "Sardar Bahadur Khan Women University", label: "Sardar Bahadur Khan Women University"},
    {value: "Sargodha Medical College", label: "Sargodha Medical College"},
    {
        value: "Sarhad University of Science &amp; Information Technology",
        label: "Sarhad University of Science &amp; Information Technology"
    },
    {value: "SEECS", label: "SEECS"},
    {value: "Services Institute of Medical Sciences", label: "Services Institute of Medical Sciences"},
    {value: "Shah Abdul Latif University", label: "Shah Abdul Latif University"},
    {
        value: "Shaheed Zulfikar Ali Bhutto Institute of Science &amp; Technology (SZABIST)",
        label: "Shaheed Zulfikar Ali Bhutto Institute of Science &amp; Technology (SZABIST)"
    },
    {
        value: "Shaikh Khalifa Bin Zayed Al-Nahyan Medical and Dental College",
        label: "Shaikh Khalifa Bin Zayed Al-Nahyan Medical and Dental College"
    },
    {value: "Shaikh Zayed Medical College", label: "Shaikh Zayed Medical College"},
    {value: "Shalamar Medical and Dental College", label: "Shalamar Medical and Dental College"},
    {value: "Sharif Medical and Dental College", label: "Sharif Medical and Dental College"},
    {value: "Shifa College of Medicine", label: "Shifa College of Medicine"},
    {value: "Sindh Agriculture University", label: "Sindh Agriculture University"},
    {value: "Sindh Madressatul Islam University", label: "Sindh Madressatul Islam University"},
    {value: "Sindh Medical College", label: "Sindh Medical College"},
    {value: "Sir Syed College of Medical Sciences", label: "Sir Syed College of Medical Sciences"},
    {
        value: "Sir Syed University Of Engg. &amp; Technology Karachi.",
        label: "Sir Syed University Of Engg. &amp; Technology Karachi."
    },
    {value: "St Joseph Govt College", label: "St Joseph Govt College"},
    {value: "St. Joseph's High School", label: "St. Joseph's High School"},
    {value: "St.John's School", label: "St.John's School"},
    {value: "St.Joseph's College For Women", label: "St.Joseph's College For Women"},
    {value: "St.Patricks Girls High School", label: "St.Patricks Girls High School"},
    {value: "State University", label: "State University"},
    {value: "Sukkur Institute of Business Administration", label: "Sukkur Institute of Business Administration"},
    {value: "Superior University Lahore", label: "Superior University Lahore"},
    {value: "Textile Institute of Pakistan", label: "Textile Institute of Pakistan"},
    {value: "The Superior College", label: "The Superior College"},
    {value: "The Women University Multan", label: "The Women University Multan"},
    {value: "University College Lahore", label: "University College Lahore"},
    {value: "University College of Medicine and Dentistry", label: "University College of Medicine and Dentistry"},
    {value: "University of Agriculture", label: "University of Agriculture"},
    {value: "University of Arid Agriculture, Murree Road", label: "University of Arid Agriculture, Murree Road"},
    {value: "University of Azad Jammu and Kashmir (AJK)", label: "University of Azad Jammu and Kashmir (AJK)"},
    {value: "University of Balochistan", label: "University of Balochistan"},
    {value: "University of Central Punjab (UCP)", label: "University of Central Punjab (UCP)"},
    {value: "University of East", label: "University of East"},
    {value: "University of Education", label: "University of Education"},
    {value: "University of Engineering &amp; Technology", label: "University of Engineering &amp; Technology"},
    {value: "University of Faisalabad", label: "University of Faisalabad"},
    {value: "University of Gujrat", label: "University of Gujrat"},
    {value: "University of Haripur", label: "University of Haripur"},
    {value: "University of Health Sciences", label: "University of Health Sciences"},
    {value: "University of Karachi", label: "University of Karachi"},
    {value: "University of Lahore", label: "University of Lahore"},
    {value: "University of Latvia. Riga", label: "University of Latvia. Riga"},
    {value: "University of Malakand", label: "University of Malakand"},
    {
        value: "University of Management &amp; Technology (UMT)",
        label: "University of Management &amp; Technology (UMT)"
    },
    {value: "University of Peshawar", label: "University of Peshawar"},
    {value: "University of Poonch", label: "University of Poonch"},
    {value: "University of Sargodha", label: "University of Sargodha"},
    {value: "University of Science &amp; Technology Bannu", label: "University of Science &amp; Technology Bannu"},
    {value: "University of Sindh", label: "University of Sindh"},
    {value: "University of South Asia", label: "University of South Asia"},
    {value: "University of Swabi", label: "University of Swabi"},
    {value: "University of Swat", label: "University of Swat"},
    {value: "University of the Punjab", label: "University of the Punjab"},
    {value: "University of Veterinary and Animal Sciences", label: "University of Veterinary and Animal Sciences"},
    {value: "University of Wah", label: "University of Wah"},
    {value: "Usman Institute of Technology (UIT)", label: "Usman Institute of Technology (UIT)"},
    {value: "Virtual University of Pakistan", label: "Virtual University of Pakistan"},
    {value: "Wah Medical College", label: "Wah Medical College"},
    {value: "Women Medical College", label: "Women Medical College"},
    {value: "Yusra Medical and Dental College", label: "Yusra Medical and Dental College"},
    {value: "Ziauddin Medical University", label: "Ziauddin Medical University"},
    { value: "Others", label: "Others" },
]

export const qualifications = [
    {value: "Non-Matriculation", label: "Non-Matriculation"},
    {value: "Matriculation/O-Level", label: "Matriculation/O-Level"},
    {value: "Intermediate/A-Level", label: "Intermediate/A-Level"},
    {value: "Bachelors", label: "Bachelors"},
    {value: "Masters", label: "Masters"},
    {value: "MBBS", label: "MBBS"},
    {value: "MD", label: "MD"},
    {value: "BDS", label: "BDS"},
    {value: "Pharm-D", label: "Pharm-D"},
    {value: "M-Phill", label: "M-Phill"},
    {value: "Doctorate", label: "Doctorate"},
    {value: "Certification", label: "Certification"},
    {value: "Diploma", label: "Diploma"},
    {value: "Short Course", label: "Short Course"}
]
